






































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ReimbursementDeadlineService } from '@/api/services/reimbursement-deadlines'
import { ReimbursementService } from '@/api/services/reimbursements'
import ReimbursementDetailModal from '@/components/ReimbursementDetailModal.vue'

export default Vue.extend({
  components: { ReimbursementDetailModal },

  data() {
    return {
      loading: false,
      deadlines: [] as any[],
      allReimbursements: [] as any[],
      columns: [
        {
          label: 'N° transaction',
          field: 'transaction.reference'
        },
        {
          label: 'Payer pour',
          field: 'beneficiary.name'
        },
        {
          label: 'Payer par',
          field: 'payerPhone'
        },
        {
          label: 'Montant Remboursé',
          field: 'amount'
        },
        {
          label: 'Date',
          field: 'createdAt'
        },
        {
          label: 'Statut',
          field: 'state'
        },
        {
          label: 'Actions',
          field: '_actions',
          align: 'left'
        }
      ],

      activeDeadline: null as any,
      selectedReimbursement: null as any
    }
  },

  computed: {
    ...mapGetters('product', ['getCurrentProduct']),

    beneficiaryGroupId(): string {
      return this.$route.params.beneficiaryGroupId
    },

    reimbursements(this: any): any[] {
      return this.activeDeadline
        ? this.allReimbursements.filter(
            (reimbursement: any) =>
              reimbursement.reimbursementDeadlineId === this.activeDeadline.id
          )
        : []
    }
  },

  async created(this: any) {
    this.loading = true
    try {
      const [deadlines, reimbursements] = await Promise.all([
        ReimbursementDeadlineService.findByBeneficiaryGroup(
          this.beneficiaryGroupId
        ),
        ReimbursementService.findByBeneficiaryGroup(
          this.beneficiaryGroupId,
          this.getCurrentProduct && this.getCurrentProduct.id
        )
      ])
      // Trier les echeances par date (l'API les renvoie triees par createdAt en premier)
      this.deadlines = [...deadlines].sort(
        (a: any, b: any) =>
          new Date(a.date).getTime() - new Date(b.date).getTime()
      )
      this.allReimbursements = reimbursements
      if (this.deadlines.length > 0) {
        this.activeDeadline = this.deadlines[0]
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  },

  methods: {
    seeEcheance(this: any, deadline: any) {
      this.activeDeadline = deadline
    },

    openDetail(this: any, reimbursement: any) {
      this.selectedReimbursement = reimbursement
    },

    closeDetail(this: any) {
      this.selectedReimbursement = null
    },

    async onResynced(this: any) {
      try {
        this.allReimbursements = await ReimbursementService.findByBeneficiaryGroup(
          this.beneficiaryGroupId,
          this.getCurrentProduct && this.getCurrentProduct.id
        )
      } catch (error) {
        console.error(error)
      }
    },

    onSeeDetails() {
      // TODO: Disbursments Details page
    }
  }
})
